module.exports = __webpack_public_path__ + "static/Nano_Logo_noedge-1c863ed9c1197dfd61d0b3983ce16dc1.svg";